import React, { createContext, useContext, useState, useCallback } from 'react';
import { adminLogin as apiLogin } from '../services/toolsApi';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [password, setPassword] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = useCallback(async (pwd) => {
    await apiLogin(pwd);
    setPassword(pwd);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    setPassword(null);
    setIsAuthenticated(false);
  }, []);

  return (
    <AdminContext.Provider value={{ password, isAuthenticated, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
